import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { input } from 'aws-amplify';

@Component({
  selector: 'app-form-checkbox',
  templateUrl: './form-checkbox.component.html',
  styleUrls: ['./form-checkbox.component.scss']
})
export class FormCheckboxComponent implements OnInit {

  @Input() value = false;
  @Input() label;
  @Input() color = 'secondary';
  @Output() change = new EventEmitter<boolean>();
 @Input() disabled :boolean =false;
  constructor() { }

  ngOnInit(): void {
  }

  toggler() {
    //this disabled added for MFA disabled
  //    if (this.disabled) {
  //     this.disabled=!this.disabled;
  //   return; // Prevent toggle if disabled
  // }
    this.value = !this.value;
    this.change.emit(this.value)
  }

}
